import {
    // ClientEvent,
    ClientEventTypes, ErrorEvent,
    ReadMessage,
    SubscribeForChatMessages,
    // WebSocketEvent
} from "../../../nodeserver/structs/websocket";
import {handleFetchError, isChatOpen, YummyServerError} from "./helpers/functions.js";
type ClientEvent = any;
class Websocket {
    websocket: WebSocket | undefined;
    private events: Map<ClientEventTypes, ((ev: any) => any)[]> = new Map();
    //ignore
    private messagesStack: any[] = [];
    private readonly onReOpen: (() => any)[] = []

    constructor() {
        this.initializeSocket();
    }

    private initializeSocket() {
        this.websocket = new WebSocket(
            `${location.protocol === 'http:' ? "ws" : 'wss'}://${location.hostname}:${location.port}/socket`);
        this.websocket.onmessage = this.onmessage.bind(this);
        this.websocket.onerror = this.showerror.bind(this);
        this.websocket.onclose = this.onclose.bind(this);
        this.websocket.onopen = this.onopen.bind(this);
    }

    onreopen(f: () => any) {
        this.onReOpen.push(f);
    }
//@ts-ignore
    on<T extends ClientEvent = ClientEvent>(event: T['event'], callback: ((ev: T) => any)): Websocket {
//@ts-ignore
        if (this.events.get(event)?.push(callback as ((ev: ClientEvent) => any)) !== null)
//@ts-ignore
            this.events.set(event, [callback as ((ev: ClientEvent) => any)]);
        return this;
    }
//@ts-ignore
    off(event: ClientEventTypes, callback: ((ev: ClientEvent) => any) | null): boolean {
        if (!this.events.has(event)) return false;
        if (callback === null) this.events.delete(event);
        else {
//@ts-ignore
            const arr: ((ev: ClientEvent) => any)[] = this.events.get(event)!,
                elIndex = arr.indexOf(callback);
            if (elIndex !== -1)
                arr.splice(elIndex, 1);
            else return false;
            if (arr.length === 0)
                this.events.delete(event);
        }
        return true;
    }

    private async onclose(event: CloseEvent) {
        await new Promise(r => setTimeout(r, 1000));
        console.warn(`Websocket had closed: ${event.reason}, ${event.code} `);
        this.initializeSocket();
    }

    private onmessage(event: MessageEvent) {
//@ts-ignore
        const data: ClientEvent = (typeof event.data == "string") ? JSON.parse(event.data) : event.data;
        this.events.get(data.event)?.forEach(callback => callback.call(this, data));
    }

    private showerror(ev: Event) {
        console.error(ev);
    }

    private onopen() {
        if (!document.hidden)
            this.subscribe();
        const stack = this.messagesStack;
        this.messagesStack = [];
        for (let msg of stack)
            this.send(msg);
        for (let ev of this.onReOpen) ev();
    }

//@ts-ignore
    private send<T extends WebSocketEvent>(json: T) {
        const d = JSON.stringify(json);
        if (this.websocket!.readyState === this.websocket!.OPEN)
            this.websocket!.send(d);
        else this.messagesStack.push(json);
    }

    public readMessages(userId: number) {
        this.send<ReadMessage>({
            event: 'read-messages',
            user_id: userId
        });
    }

    static Instance: Websocket;

    public subscribeForChatMessages(subscribe: boolean) {
        this.send<SubscribeForChatMessages>({
            event: 'chat-subscribe',
            subscribe: subscribe
        });
    }

    unsubscribe() {
        this.send({event: 'unsubscribe-events'});
    }

    subscribe() {
        this.send({event: 'subscribe-events'});
    }
}

// const interval = setInterval(updateSocket, 50);
// function updateSocket() {
// // @ts-ignore
//     if (user_id && !globalThis.socket) {
// // @ts-ignore
//         globalThis.socket = (Websocket.Instance = new Websocket());
//         clearInterval(interval);
//     }
// }
// $(()=>(updateSocket(), clearInterval(interval)));
//@ts-ignore
if (!Websocket.Instance)
    Websocket.Instance = new Websocket();
else console.warn('Websocket already initialized');
(window as any).socket = Websocket.Instance;

Websocket.Instance.on<ErrorEvent>('error', error => {
    handleFetchError(new YummyServerError(error.error, error.error_code ?? 0, 'Ошибка', error.error_name ?? 'Undefined Error'));
});


// on tab unfocus - unsubscribe from chat messages
let focused: boolean = true;
document.addEventListener("visibilitychange", (event) => {
    if (document.visibilityState == "visible") {
        focused = true;
        Websocket.Instance.subscribe();
    } else {
        focused = false;
        Websocket.Instance.unsubscribe();
    }
});

export {Websocket};
